var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBenchmarkSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49984 11.6758L11.8773 14.4136L10.7157 9.25371L14.5832 5.78198L9.49025 5.33425L7.49984 0.467957L5.50942 5.33425L0.416504 5.78198L4.284 9.25371L3.12234 14.4136L7.49984 11.6758Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenchmarkSelected);
export default __webpack_public_path__ + "static/media/icon_benchmark_selected.c1c7ef05c4d81e3acd309e4225b4de21.svg";
export { ForwardRef as ReactComponent };